import * as React from 'react';
import { WPBlockProps } from './types';
import parse, { domToReact } from 'html-react-parser';

export default function WpDefaultHtml({
  block,
  parentLength,
  prefix,
}: WPBlockProps): JSX.Element | null {
  const classDef = parentLength ? prefix + 'col-count-' + parentLength : '';
  const content =
    (block.isDynamic ? block.dynamicContent : block.saveContent) ?? '';
  return (
    <div
      className={classDef}
      onClick={(event: React.MouseEvent) => {
        // hack to give the click event to a link (a-Element)
        // within the childnodes of the event-target
        const children = (event.target as any).childNodes;
        const array = [...children];
        array.forEach((elem) => {
          if (elem.nodeName === 'A') {
            elem.click();
          }
        });
      }}
    >
      {parse(content)}
    </div>
  );
}
